import { defineComponent as _defineComponent } from 'vue'
import ListItemText from "@/components-UI/list/items/ListItemText.vue";
import { computed } from "vue";

interface Props {
    value: boolean,
    trueText: string,
    falseText: string,
    trueColor?: 'green',
    falseColor?: 'red',
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemBoolean',
  props: {
    value: { type: Boolean },
    trueText: null,
    falseText: null,
    trueColor: null,
    falseColor: null
  },
  setup(__props: any) {

const props = __props as {
    value: boolean,
    trueText: string,
    falseText: string,
    trueColor?: 'green',
    falseColor?: 'red',
}



const getValue = computed(() => props.value ? props.trueText : props.falseText);
const getColor = computed(() => props.value ? props.trueColor : props.falseColor);

return { __sfc: true,props, getValue, getColor, ListItemText }
}

})